var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('LogoLink',{staticClass:"logo-link"}),_c('SectionComponent',{staticClass:"section-404",attrs:{"section":_vm.page404,"is-logo-visible":false}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }